export const FEATURE_TOGGLE_KEY_PREFIX = 'ww_ft_';
export const FEATURE_TOGGLE_KEY_PREFIX_V2 = `${FEATURE_TOGGLE_KEY_PREFIX}v2_`;

export enum AppBannerValues {
    'big',
    'none',
    'small',
    'smart',
}

export enum PdpExtraAddToCartBtnValues {
    'gallery',
    'none',
    'sticky',
}

export enum PdpSizeSelectorNoteValues {
    'red',
    'charcoal',
    'no_note',
}

export enum ServerPageCachingValues {
    'full',
    'partial',
    'none',
}

export const StringFeatureToggleOptions = {
    p100AppBanner: AppBannerValues,
    p100PdpExtraAddToCartBtn: PdpExtraAddToCartBtnValues,
    p100PdpSizeSelectorNote: PdpSizeSelectorNoteValues,
    p100ServerPageCaching: ServerPageCachingValues,
};

/**
 * IMPORTANT:
 * While creating a string feature toggle please do following:
 * 1. Create an enum with possible values.
 * 2. Add it to `StringFeatureToggleOptions`.
 * 3. Finally add it to the `FeatureToggles` interface
 * 4. This enusres the string FT values are available to FT browser extension.
 */
export interface FeatureToggles {
    clubHeaderBarBanner?: boolean;
    clubLinkTabHighlight?: boolean;
    isBlackFridayActive?: boolean;
    isCyberMondayActive?: boolean;
    isDefaultCookieBannerEnabled?: boolean;
    isFacebookLoginDesktopEnabled?: boolean;
    isOneTrustCookieBannerEnabled?: boolean;
    isPdpTaxDisclaimerEnabled?: boolean;
    isNewTranslationModeEnabled?: boolean;
    isSpecialSalesEnabled?: boolean;
    isNativeVideoPlayerEnabled?: boolean;
    isFabricSamplesEnabled?: boolean;
    interiorServiceInNav?: boolean;
    showTranslation?: boolean;
    specialPrice?: boolean;

    // launch darkly
    p100PdpShowMoodImageFirst?: boolean;
    p100PdpValueProps?: boolean;
    p100Sustainability?: boolean;
    p100PlpStrongestSellingSize?: boolean;
    p100DynamicSearchSuggestions?: boolean;
    p100LooksClientSideNav?: boolean;
    p100ShowNewS2CBanner?: boolean;
    p100HotjarTracker?: boolean;
    // String launch darkly FTs.
    p100PdpExtraAddToCartBtn?: keyof typeof PdpExtraAddToCartBtnValues;
    p100AppBanner?: keyof typeof AppBannerValues;
    p100PdpSizeSelectorNote?: keyof typeof PdpSizeSelectorNoteValues;
    p100ServerPageCaching?: keyof typeof ServerPageCachingValues;

    // query toggles
    skuDiver?: boolean;
    p100Pdp?: boolean;
    assemblyService?: boolean;
    bellaCart?: boolean;
}
